import React, { useState, useEffect } from "react";
import { checkResult, createSelectOption } from "@/common";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Modal, message, Button, Form, Input, Select } from "antd";

const NAME = "projectEditUnit";

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = useState(false);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { show, hide, width = 660, id, callback } = modalProps;
    const [data, setData] = useState([]);

    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
    };

    const getRecUnitDetail = id => {
        BaseService.list({
            table: "thtt_project_recommend",
            where: {
                id: id,
                "is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            setData(data);
        })
    }

    useEffect(() => {
        if (id) getRecUnitDetail(id)
    }, [id])

    const onSubmit = async (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (id !== 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.put({
                        table: "thtt_project_recommend", data: {
                       //     org_name: values.org_name,
                       //     org_password: values.org_password,
                            org_category: values.org_category,
                        }, where: { id: id }
                    });
                    setLoading(false);
                    if (!checkResult(res)) return;
                    message.success("修改成功！");
                    if (callback) callback(res.data.result.id);
                    hide();
                }
            }
            if (id === 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.add({
                        table: "thtt_project_recommend", data: {
                            org_name: values.org_name,
                            org_password: values.org_password,
                            org_category: values.org_category,
                            identify: 1,
                        }
                    });
                    setLoading(false);
                    if (!checkResult(res)) return;
                    message.success("添加成功！");
                    hide();
                    if (callback) callback();
                }
            }
        });
    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={onSubmit}>
                <div style={{ border: "1px solid #d9d9d9" }}>
                    <div style={{ textAlign: "center", backgroundColor: "#fafafa", marginBottom: 30, height: 50, borderBottom: "1px solid #d9d9d9" }}>
                        <h2>{(id !== 0) ? '修改推荐单位信息' : '新增推荐单位'}</h2>
                    </div>
                    <div style={{ marginLeft: 40 }}>
                        <Form.Item label="推荐单位名称" type="flex" style={{ width: 620 }}>
                            {(id !== 0) ? (data.org_name)
                                : (getFieldDecorator('org_name', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入推荐单位名称',
                                        },
                                    ],
                                })(<Input placeholder="请输入推荐单位名称" style={{ width: 400 }} />))}
                        </Form.Item>

                        <Form.Item label="推荐单位密码" type="flex" style={{ width: 620 }}>
                            {(id !== 0) ? (data.org_password)
                                : (getFieldDecorator('org_password', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入推荐单位密码',
                                        },
                                    ],
                                })(<Input placeholder="请输入推荐单位密码" style={{ width: 150 }} />))}
                        </Form.Item>
                        <Form.Item label="机构类别" type="flex" style={{ width: 620 }}>
                            {(id !== 0) ? (getFieldDecorator('org_category', {
                                initialValue: String(data["org_category"]) || undefined, rules: [
                                    {
                                        required: true,
                                        message: '请选择机构类别',
                                    },
                                ],
                            }
                            )(
                                <Select placeholder="-请选择-" style={{ width: "150px" }}>
                                    {createSelectOption([
                                        { label: "-请选择-", value: "" },
                                        { label: "科研院所", value: "1" },
                                        { label: "大专院校", value: "2" },
                                        { label: "专业学会", value: "3" },
                                        { label: "行业协会", value: "4" },
                                        { label: "央企/国企", value: "5" },
                                        { label: "非公企业", value: "6" },
                                        { label: "产业园区", value: "7" },
                                        { label: "其它", value: "8" },
                                    ])}
                                </Select>
                            )) : (getFieldDecorator('org_category', {
                                initialValue: '', rules: [
                                    {
                                        required: true,
                                        message: '请选择机构类别',
                                    },
                                ],
                            }
                            )(
                                <Select placeholder="-请选择-" style={{ width: "150px" }}>
                                    {createSelectOption([
                                        { label: "-请选择-", value: "" },
                                        { label: "科研院所", value: "1" },
                                        { label: "大专院校", value: "2" },
                                        { label: "专业学会", value: "3" },
                                        { label: "行业协会", value: "4" },
                                        { label: "央企/国企", value: "5" },
                                        { label: "非公企业", value: "6" },
                                        { label: "产业园区", value: "7" },
                                        { label: "其它", value: "8" },
                                    ])}
                                </Select>
                            ))}
                        </Form.Item>
                        <p style={{ textAlign: "center", marginTop: 50, marginBottom: 20 }}>
                            <Button type="primary" onClick={onSubmit} loading={loading}>{(id !== 0) ? '修改' : '新增'}</Button>
                            <Button onClick={hide} style={{ marginLeft: 20 }}>取消</Button>
                        </p>
                    </div>
                </div>
            </Form>
        </Modal>
    );
})

export default App;